// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__32TvF","row":"styles_row__1G5hp"};